import React from 'react';
import { Bar, Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import './AdminDashboard.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Tooltip, Legend);

export default function AdminDashboard({ analytics }) {
  // Dados fake para exemplo visual
  const barData = {
    labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho'],
    datasets: [
      {
        label: 'QR Codes Gerados',
        data: analytics.qrCodesByMonth || [12, 19, 3, 5, 2, 3],
        backgroundColor: '#1B4965',
      },
    ],
  };

  const pieData = {
    labels: ['Usuários', 'Admins'],
    datasets: [
      {
        label: 'Usuários',
        data: [analytics.totalUsers - analytics.adminUsers, analytics.adminUsers],
        backgroundColor: ['#5FA8D3', '#13294B'],
      },
    ],
  };

  return (
    <div className="admin-dashboard-visual">
      <div className="dashboard-indicators">
        <div className="indicator">
          <div className="indicator-value">{analytics.totalUsers ?? '--'}</div>
          <div className="indicator-label">Usuários</div>
        </div>
        <div className="indicator">
          <div className="indicator-value">{analytics.adminUsers ?? '--'}</div>
          <div className="indicator-label">Admins</div>
        </div>
        <div className="indicator">
          <div className="indicator-value">{analytics.totalQRs ?? '--'}</div>
          <div className="indicator-label">QR Codes</div>
        </div>
      </div>
      <div className="dashboard-charts">
        <div className="chart-block">
          <Bar data={barData} options={{ responsive: true, plugins: { legend: { display: false } } }} />
        </div>
        <div className="chart-block">
          <Pie data={pieData} options={{ responsive: true }} />
        </div>
      </div>
    </div>
  );
}
